import React, { useEffect, useState } from 'react';
import { Space } from 'antd';
import Image from '@base/lib/ThemeImage';
import { Rate } from '@base/lib/Rate';
import styles from './index.module.less';
import cn from 'classnames';
import ReviewDetailModal from '@app/activity/testerClub/ReviewDetailModal';
import type { IReview } from 'mod/review/interface';
import { PreviewThumb } from '@base/snippets/PreviewThumb';
import { useTrans } from 'base/utils/i18n'

type IProps = {
    review: IReview;
    className?: string;
    imageWidth?: number;
}

const TesterReviewItem: React.FC<IProps> = (props) => {

    const { review, className, imageWidth = 126 } = props;
    const [detailVisible, setDetailVisible] = useState<boolean>(false)

    const { t } = useTrans();

    const onCloseDetailModal = () => {
        setDetailVisible(false)
    }

    return (
        <>
            <ReviewDetailModal
                review={review}
                open={detailVisible}
                onClose={onCloseDetailModal}
            />

            <div
                className={className}
            >
                <div className={cn(styles['review-item'], 'g-review-item text-left')}>
                    <Image
                        className={'g-decoration-image'}
                        fixed
                        src={"asset/width-78/picture/5b1c4a5bfb7d69ae79f1af5d299cfd81.png"}
                        width={26}
                        height={24}
                    />
                    <p className={cn(styles['review-text'], 'g-text')}>
                        {review.reviewInfo}
                    </p>

                    <div className={cn(styles['review-name-rate'], 'g-name-rate flex flex-justify')}>
                        <span className={cn(styles['review-name'], 'g-name')}>{review.username}</span>
                        <Rate value={review.score || 5.0} starSize={15}/>
                    </div>

                    <div className={cn(styles['review-images'], 'g-images')}>
                        <Space size={10} wrap>
                            {review?.reviewAsset?.slice(0, 3).map((raItem, raIndex) => {
                                return (
                                    <div
                                        className={styles['image-item-wrap']}
                                        key={raIndex}
                                        style={{
                                            width: imageWidth,
                                            height: imageWidth,
                                        }}
                                    >
                                        <PreviewThumb
                                            fixed
                                            className={'g-asset'}
                                            key={raIndex}
                                            url={raItem.link || raItem.thumbLink}
                                            width={imageWidth}
                                            height={imageWidth}
                                        />
                                    </div>
                                )
                            })}
                        </Space>
                    </div>

                    <div className={cn(styles['view-more'], 'text-right')}>
                        <span
                            className={'pointer'}
                            onClick={() => setDetailVisible(true)}
                        >
                            {t('web_common_view_more')} &gt;
                        </span>
                    </div>
                </div>
            </div>
        </>
    );
};

export default TesterReviewItem